import { InlineProductsById } from '../CommonScanSchemas';
import { Scope } from '../OptimizedValueExpressions';
import { initDeoptimizedGroup, initDeoptimizedLineItem, initDeoptimizedOption, initDeoptimizedScan, initDeoptimizedTask, ScanHomeFacts } from '../ScanRoot';
import {
  ScanTemplateGroup,
  ScanTemplateLineItem,
  ScanTemplateOption,
  ScanTemplateRoot,
  ScanTemplateTask,
} from '../ScanTemplateRoot';

import {
  getOptimizedGroup,
  getOptimizedLineItem,
  getOptimizedOption,
  getOptimizedScan,
  getOptimizedTask,
} from './getOptimizedScan';
import {
  ScanGroupOptimized,
  ScanLineItemOptimized,
  ScanOptionOptimized,
  ScanRootOptimized,
  ScanTaskOptimized,
} from './ScanRootOptimizedSchemas';

// **************************************************************
// Scan INITIALIZATION
// **************************************************************

/** With `inlineProductsById`, a single-SKU line item is seeded from its product (see initDeoptimizedLineItem). */
export const initLineItemFromTemplate = (
  template: ScanTemplateLineItem,
  parentScope: Scope,
  now: number = Date.now(),
  inlineProductsById?: InlineProductsById,
): ScanLineItemOptimized => getOptimizedLineItem(initDeoptimizedLineItem(template, now, inlineProductsById), template, parentScope);

export const initOptionFromTemplate = (
  template: ScanTemplateOption,
  parentScope: Scope,
  now: number = Date.now(),
  inlineProductsById?: InlineProductsById,
): ScanOptionOptimized => getOptimizedOption(initDeoptimizedOption(template, now, inlineProductsById), template, parentScope);

// task starts with no options selected
export const initTaskFromTemplate = (template: ScanTemplateTask, parentScope: Scope, now: number = Date.now()): ScanTaskOptimized =>
  getOptimizedTask(initDeoptimizedTask(template, now), template, parentScope);

export const initGroupFromTemplate = (
  rootTemplate: ScanTemplateRoot,
  groupTemplate: ScanTemplateGroup,
  parentScope: Scope,
  now: number = Date.now(),
): ScanGroupOptimized => getOptimizedGroup(rootTemplate, initDeoptimizedGroup(rootTemplate, groupTemplate, now), groupTemplate, parentScope);

export const initScanFromTemplate = (template: ScanTemplateRoot, now: number = Date.now(), homeFacts?: ScanHomeFacts): ScanRootOptimized =>
  getOptimizedScan(initDeoptimizedScan(template, now, homeFacts), template);
